import { NavigationGuard } from 'vue-router'

export const ifAuthenticated: NavigationGuard = (to, from, next) => {
  // Точка расширения, тут раньше были логи
  return next()
}
